import { InjectionToken } from "@angular/core";
import { PreguntaImportador } from "@shared/clases/importador";

export const PreguntaImportadorToken = new InjectionToken<PreguntaImportador>("PreguntaImportadorToken");
